import React from "react";
import Card from "./Card";
import { CardSelectorWrapper } from "./styles";

const CardSelector = ({ list, selected, onChange }) => {
  return (
    <CardSelectorWrapper>
      {list.map(({ display_name, value }, index) => (
        <Card
          key={index}
          title={display_name}
          selected={selected.has(value)}
          onChange={() => onChange(value)}
        />
      ))}
    </CardSelectorWrapper>
  );
};

export default CardSelector;
